import React, { useState } from 'react';
import { Form, Input, Button, message, Modal, FloatButton } from 'antd';
import { MailOutlined, MessageOutlined } from '@ant-design/icons';
import { TextService } from '../../Services/TextService';
import { ContactService } from '../../Services/ContactService';

interface ContactFormProps {
    style?: React.CSSProperties;
}

const ContactForm: React.FC<ContactFormProps> = ({ style }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const GetText = TextService.GetText;

    const onFinish = async (values: { email: string; message: string }) => {
        setLoading(true);
        try {
            await ContactService.SendContactMail({
                email: values.email,
                description: values.message
            });

            message.success(GetText("ContactForm_Success"));
            form.resetFields();
            setModalOpen(false);
        } catch (error) {
            message.error(GetText("ContactForm_Error"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <FloatButton
                icon={<MessageOutlined />}
                type="primary"
                style={{
                    right: 24,
                    bottom: 24,
                    width: 60,
                    height: 60,
                    border: '3px solid #ff7a00',
                    boxShadow: '0 4px 12px rgba(255, 122, 0, 0.4)'
                }}
                onClick={() => setModalOpen(true)}
                tooltip={GetText("ContactForm_Title")}
                aria-label={GetText("ContactForm_Title")}
            />

            <Modal
                title={
                    <div style={{ textAlign: 'center' }}>
                        <MailOutlined style={{ fontSize: 24, marginRight: 8 }} />
                        {GetText("ContactForm_Title")}
                    </div>
                }
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                width={500}
            >
                <p style={{ textAlign: 'center', marginBottom: 24, color: '#666' }}>
                    {GetText("ContactForm_Description")}
                </p>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        label={GetText("ContactForm_EmailLabel")}
                        name="email"
                        rules={[
                            { required: true, message: GetText("ContactForm_EmailRequired") },
                            { type: 'email', message: GetText("ContactForm_EmailInvalid") }
                        ]}
                    >
                        <Input
                            placeholder={GetText("ContactForm_EmailPlaceholder")}
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label={GetText("ContactForm_MessageLabel")}
                        name="message"
                        rules={[
                            { required: true, message: GetText("ContactForm_MessageRequired") }
                        ]}
                    >
                        <Input.TextArea
                            placeholder={GetText("ContactForm_MessagePlaceholder")}
                            rows={4}
                            maxLength={500}
                            showCount
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block
                            icon={<MailOutlined />}
                        >
                            {GetText("ContactForm_Submit")}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default ContactForm;
